module.exports = __webpack_public_path__ + "img/400.cb6fa32e.png";